//@flow
import React from 'react';
import {Link} from 'react-router-dom';

import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CustomButton from '../CustomButton/CustomButton';
import type {Node} from 'react';
import {Hidden, IconButton} from '@material-ui/core';

type Props = {
  icon: Node,
  href?: string,
  to?: string,
  title: string,
  target?: string,
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: '.75rem 1.25rem',
  },
  title: {
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export default function ActionAppBarIconButton(props: Props) {
  const {icon, href, to, title, target} = props;
  const classes = useStyles();

  const component = to ? Link : 'a';

  return (
    <>
      <Hidden mdUp>
        <IconButton
          component={component}
          href={href}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          to={to}
        >
          {icon}
        </IconButton>
      </Hidden>
      <Hidden smDown>
        <CustomButton
          className={classes.root}
          component={component}
          href={href}
          color="default"
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          to={to}
          startIcon={icon}
        >
          <Typography
            component="span"
            className={classes.title}
            color="textSecondary"
          >
            {title}
          </Typography>
        </CustomButton>
      </Hidden>
    </>
  );
}
